export default {
  LONG: "long",
  MEDIUM: "medium",
  SHORT: "short"
};